import { render, staticRenderFns } from "./SystemError.vue?vue&type=template&id=02c71b08&scoped=true&lang=pug"
import script from "./SystemError.vue?vue&type=script&lang=ts"
export * from "./SystemError.vue?vue&type=script&lang=ts"
import style0 from "./SystemError.vue?vue&type=style&index=0&id=02c71b08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02c71b08",
  null
  
)

export default component.exports